/*eslint-disable react/no-danger*/

import { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { useSelector } from "react-redux"

import Dialog from "@/components/Dialog"
import settings from "@/utils/settings"

import Trigger from "./Trigger"

const DigitalLicenseDialog = () => {
  const [isShowing, setIsShowing] = useState(false)
  const intl = useIntl()
  const isCaDisclosureUpdateEnabled = useSelector(
    state => state.featureFlags.caDisclosureUpdateEnabled
  )

  return (
    <Dialog
      heading={intl.formatMessage({ id: "digital_license.modal.modal_header" })}
      id="digital-license-modal"
      isShowing={isShowing}
      onChangeShow={setIsShowing}
      trigger={<Trigger />}
    >
      <div>
        <Choose>
          <When condition={isCaDisclosureUpdateEnabled} >
            <FormattedMessage
              id="digital_license.modal.modal_text_lifetime"
              values={{
                li: chunks => <li>{chunks}</li>,
                link: chunks => (
                  <a
                    href={settings.vst_support_california_disclosure_url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {chunks}
                  </a>
                ),
                strong: chunks => <strong>{chunks}</strong>,
                ul: chunks => <ul className="mt-3">{chunks}</ul>,
              }}
            />
          </When>
          <Otherwise>
            <FormattedMessage
              id="digital_license.modal.modal_text"
              values={{
                link: (
                  <a
                    href={settings.vst_support_california_disclosure_url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <FormattedMessage id="common.support_page" />
                  </a>
                )
              }}
            />
          </Otherwise>
        </Choose>
      </div>
    </Dialog>
  )
}

export default DigitalLicenseDialog
